import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export const adminApi = (key) =>
  axios.create({
    baseURL: API,
    headers: { "Content-Type": "application/json", "X-Admin-Key": key },
  });

import links from "../links.json";

export const SITE = {
  domain: links.domain || "https://drpriyankagupta.co.in",
  webhookUrl: "https://script.google.com/macros/s/AKfycbyQjKlNm896Ak4guETSHS_lzG1XPzCjPB9TTHx_1_38Py7srvj647Ve_CIIWDWFpbCq/exec",
  doctorName: "Dr. Priyanka Gupta",
  tagline: "Expert Care for Your Journey to Motherhood",
  phone: "+917289999292",
  phoneDisplay: "072899 99292",
  whatsapp: links.whatsapp || "917289999292",
  email: "appointments@drpriyankagupta.com",
  address: "Wellmed Hospitals, 242, Sector 39, Gurugram, Haryana 122003",
  rating: "4.8",
  reviewCount: "500+",
  yearsExp: "20+",
  babiesDelivered: "20,000+",
  youtube: links.youtube,
  instagram: links.instagram,
  facebook: links.facebook,
  practo: links.practo,
  googleReviews: links.googleReviews,
  sheetsLink: links.sheetsLink,
  googleMaps: links.googleMaps || "https://maps.google.com/?q=Wellmed+Hospitals+Sector+39+Gurugram",
  googleMapsEmbed: links.googleMapsEmbed || "https://www.google.com/maps?q=Wellmed+Hospitals+Sector+39+Gurugram&output=embed"
};

export const whatsappLink = (text = "Hello, I would like to book an appointment with Dr. Priyanka Gupta.") =>
  `https://wa.me/${SITE.whatsapp}?text=${encodeURIComponent(text)}`;
